import React from 'react';

interface Props {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  htmlFor?: string;
  /** Rendered beside the label on the right, e.g. a Caps Lock warning. */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

// Same field chrome as slightercrm/src/components/FormField.tsx.
export const FormField: React.FC<Props> = ({ label, hint, error, required, htmlFor, aside, children }) => (
  <div className="mb-4 block">
    <label htmlFor={htmlFor} className="mb-1.5 flex items-baseline justify-between gap-3">
      <span className="shrink-0 whitespace-nowrap text-[13px] font-medium text-text-secondary">
        {label}{required && <span className="ml-0.5 text-primary">*</span>}
      </span>
      {aside ?? (hint && !error && <span className="min-w-0 text-right text-2xs text-text-muted">{hint}</span>)}
    </label>
    {children}
    {error && (
      <span className="mt-1.5 flex items-center gap-1.5 text-xs text-danger">
        <span className="inline-block h-1 w-1 rounded-full bg-danger" />
        {error}
      </span>
    )}
  </div>
);
